import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

function isTokenExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}

const AuthenticatedComponents = (props) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('access_token');
            setError('Session expired');
            return;
        }
        setAuthenticated(true);
    }, []);

    if (error) return <Redirect to='/login' />;
    if (authenticated) return props.children;
    return null;
}
export default AuthenticatedComponents;